<template>
  <div class="room">
    <div class="room_header">
      <router-link v-bind:to="{ name: 'Rooms'}" class="rooms_backLink">←もどる</router-link>
    </div>
    <div v-if="isRange">
      <div class="message_fetchButton" v-if="!isLoading && !isStartScroll" @click="fetchPastmessages">以前のメッセージの取得</div>
      <loading class="message_loading" :show="isLoading"/>
      <div class="messages">
        <ul>
          <li v-for="message in messages" :class="messageClass(Object.values(message)[0].account.id)">
            <div class="message_pic">
              <img :src=Object.values(message)[0].account.pictureSrc></img>
            </div>
            <div class="message_body">
              <div class="mesasge_name">{{Object.values(message)[0].account.name}}</div>
              <div class="message_text">{{Object.values(message)[0].body}}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="message_form">
        <form @submit.prevent='onSubmit'>
          <div class="message_formWapper">
            <textarea wrap="hard" cols="30" v-model="body" class="message_textField" />
            <input type="submit" value="送信" class="message_submit">
          </div>
        </form>
      </div>
    </div>
    <div v-if="isRange === false">
      <p>部屋の外にいます</p>
    </div>
    <div v-if="isRange === null">
      <loading class="message_loading" :show="true"/>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import 'firebase/firestore'
import Loading from '@/components/Loading'

export default {
  name: 'Room',
  data () {
    return {
      id: null,
      body: '',
      room: null,
      messages: [],
      isLoading: false,
      isfetching: false,
      isStartScroll: true,
    }
  },
  components: {
   'loading': Loading
  },
  methods: {
    onSubmit: function(){
      if (!this.body) return
      const body = this.body
      this.body = ''
      store.getters.firebase.firestore().collection("message").add(
        {
          body: body,
          _createdAt: Date.now(),
          account: { ...store.getters.currentAccount  },
          roomId: this.id,
        }
      )
      .then(docRef => {
        scrollTo(0, document.documentElement.scrollHeight)
        const messageId = docRef.id
        store.getters.firebase.firestore().collection("room").doc(this.id).set({ messages: { [messageId]: true } }, { merge: true })
      })
      .catch(e => alert(e))
    },
    messageClass: function(id) {
      return store.getters.currentAccount.id == id ? 'myMessage' : ''
    },
    fetchPastmessages: function() {
      this.isLoading = true
      this.isfetching = true
      const prevHtmlHeight = document.documentElement.scrollHeight;
      const prevScrollPoint = window.pageYOffset;
      const lastCreatedAt = Object.values(this.messages[0])[0]._createdAt
      store.getters.firebase.firestore().collection("message").orderBy('_createdAt', 'desc').where("roomId", "==", this.$route.params.id).startAfter(lastCreatedAt).limit(20).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.messages.unshift({[doc.id]: doc.data()})
        });
        this.isLoading = false
      }).then(() => {
        this.$nextTick(function(){
          scrollTo(0, document.documentElement.scrollHeight - prevHtmlHeight + prevScrollPoint)
        })
      })
      .catch(function(error) {
        this.isLoading = false
        this.isfetching = false
        console.log("Error getting documents: ", error);
      });;
    },
    getScrollBottom: function () {
      let body = window.document.body;
      let html = window.document.documentElement;
      let scrollTop = body.scrollTop || html.scrollTop;
      return html.scrollHeight - html.clientHeight - scrollTop;
    }
  },
  computed: {
    isRange: function(){
      if(this.room == null) { return null } // created内のコールバック終了より発火が速いのでこの条件文
      const lat1 = this.room.location.latitude * Math.PI / 180;
      const lng1 = this.room.location.longitude * Math.PI / 180;
      const lat2 = store.getters.location.latitude * Math.PI / 180;
      const lng2 = store.getters.location.longitude * Math.PI / 180;
      const distance = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
      return distance < 0.5; //500m以内
    }
  },
  async created() {
    const doc = await store.getters.firebase.firestore().collection("room").doc(this.$route.params.id).get()
    if (doc.exists) {
      this.id = this.$route.params.id
      this.room = doc.data()
    } else {
      console.log("No such document!");
    }
  },
  updated() {
    if(this.isfetching) {
      this.isfetching = false
      return;
    }
    if(!this.isStartScroll && 900 <= this.getScrollBottom()){ //自分がタイムラインの下の方見ていた時に、他の人から投稿があった時スクロール
      return;
    }
    if(this.isStartScroll) {
      this.isStartScroll = false
    }
    scrollTo(0, document.documentElement.scrollHeight)
  },
  mounted() {
    store.getters.firebase.firestore().collection("message").orderBy('_createdAt', 'desc').where("roomId", "==", this.$route.params.id).limit(30).onSnapshot(querySnapshot => {
      const object = this
      querySnapshot.docChanges().forEach(function(change) {
        let unshiftMessages = []
        let pushMessages = []
        if (change.type === "added") {
          if(object.messages[0] != null && change.doc.data()._createdAt < Object.values(object.messages[0])[0]._createdAt) {
            unshiftMessages.unshift({[change.doc.id]: change.doc.data()})
          } else {
            pushMessages.push({[change.doc.id]: change.doc.data()})
          }
          object.messages = [...unshiftMessages, ...object.messages, ...pushMessages]
          object.isStartScroll = true
        }
      })
    })
  }
}
</script>

</script>
<style scoped>
h1, h2 {
  font-weight: normal;
}

.room {
  max-width: 800px;
  margin: 0 auto;
}

.messages {
  /* padding-bottom: 70px; */
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 20px 10px;
  display: flex;
}

li.myMessage {
  flex-direction: row-reverse;
}

li.myMessage .message_pic,
li.myMessage .mesasge_name
{
  display: none;
}

li.myMessage .message_text
{
  background-color: #eee;
  border: none;
}


a {
  color: #42b983;
}

.message_pic {
  padding-top: 10px;
}

.message_pic img {
  border-radius: 50%;
  width: 40px;
}

.message_body {
  margin: 0 10px;
}

.mesasge_name {
  font-size: 11px;
  text-align: left;
  padding-left: 10px;
}

.message_text {
  border: 1px solid #ccc;
  padding: 5px 15px;
  border-radius: 30px;
  text-align: left;
}

.message_form {
  height: 50px;
  background-color: #fff;
}

.message_submit {
  position: absolute;
  right: 15px;
  bottom: 8px;
  font-weight: bold;
  color: #3293ff;
  background-color: #fff;
  font-size: 14px;
  border-radius: 0;
  -webkit-box-sizing: content-box;
  -webkit-appearance: button;
  appearance: button;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
}

.message_formWapper {
  border: 1px solid #ccc;
  border-radius: 20px;
  height: 40px;
  width: 80%;
  padding: 1px 20px;
  font-size: 17px;
  margin: 15px auto;
  position: relative;
  text-align: left;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}

.message_formWapper:focus {
  top: 0;
}

.message_textField {
  height: 30px;
  margin: 0;
  padding: 5px 0;
  border: none;
  width: 85%;
  font-size: 17px;
  line-height: 1.7;
  resize: none;
  outline: none;
}

.message_fetchButton {
  width: 60%;
  margin: 15px auto;
  border-radius: 30px;
  border: 1px solid #eee;
  cursor: pointer;
}

.message_loading {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.room_header {
  /* position: fixed;
  top: 0; */
  padding: 5px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Room.vue